import styled from "styled-components";

import { colors } from "application/styles/colors";

interface StyledProps {
  marginBottom?: number;
}

interface SignUpProps {
  isSignUp?: boolean;
}

export const AuthWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const AuthContainer = styled.div<SignUpProps>`
  flex: 1;
  display: flex;
  padding-top: 80px;
  align-items: center;
  flex-direction: column;

  @media only screen and (max-width: 1023px) {
    width: 100%;
    height: ${({ isSignUp }) => isSignUp ? "calc(100vh - 147px)" : "calc(100vh - 88px)"};
    justify-content: space-between;
    overflow-y: auto;
    padding-top: ${({ isSignUp }) => isSignUp ? "180px" : "120px"};
    padding-bottom: 60px;
  }

  @media only screen and (max-width: 674px) {
    padding-bottom: 280px;
     padding-top: ${({ isSignUp }) => isSignUp ? "140px" : "120px"};
  }
`;

export const AuthContent = styled.div`
  width: 357px;

  @media only screen and (max-width: 1023px) {
    width: 642px;
  }

  @media only screen and (max-width: 674px) {
    width: calc(100% - 32px);
    padding: 0 16px;
  }
`;

export const AuthTitle = styled.h2`
  margin-bottom: 32px;
  /* Font-style */
  font-size: 40px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  font-style: normal;
  font-family: "Times";
  color: ${colors.black};
`;

export const AuthBottomWrapper = styled.div`
  display: flex;
  margin-top: 32px;
  & > button:first-child {
    margin-right: 24px;
  }
`;

export const AuthInputWrapper = styled.div`
  margin-bottom: 16px;
`;

export const AuthDoubleInputWrapper = styled.div<StyledProps>`
  display: flex;
  margin-bottom: ${({ marginBottom }) => marginBottom ?? 16}px;

  div {
    flex: 1;
  }
  & > div:first-child {
    margin-right: 24px;
  }

  @media only screen and (max-width: 674px) {
    flex-direction: column;
    margin-bottom: 16px;

    & > div:first-child {
      margin-right: unset;
      padding-bottom: 16px;
    }
  }
`;
